import { onBeforeUnmount, onMounted, watch } from "vue";
import Settings, { CANVAS_UI_SCALES } from "@/stores/Settings";

/** Variables CSS lues par `.canvas-icon-scaled` / `.canvas-text-scaled` (cf. canvas-theme.scss). */
export const CANVAS_ICON_SCALE_VAR = "--canvas-icon-scale";
export const CANVAS_TEXT_SCALE_VAR = "--canvas-text-scale";

/** Facteur des icônes : barre d'outils, bulles des onglets, barres flottantes. */
export function getCanvasIconScale(): number {
  return CANVAS_UI_SCALES[Settings.canvasIconSize] ?? 1;
}

/** Facteur des textes : en-tête, volets, bandeaux. */
export function getCanvasTextScale(): number {
  return CANVAS_UI_SCALES[Settings.canvasTextSize] ?? 1;
}

/**
 * Tailles de l'interface de l'outil dessin (réglages `canvasIconSize` et
 * `canvasTextSize`, modale Affichage) : réduire les boutons sans rendre
 * illisibles l'en-tête et les volets, ou l'inverse.
 *
 * Chaque élément porte la classe de sa famille, `canvas-icon-scaled` ou
 * `canvas-text-scaled`, qui applique `zoom: var(--canvas-…-scale)`. Le zoom
 * CSS agrandit tout ce que contient l'élément — icônes, textes, marges — ET ses
 * propres longueurs (`top`, `left`, `width`), si bien que les constantes de
 * layout restent exprimées une seule fois, en taille de base (cf.
 * CanvasLayoutState pour le passage d'une famille à l'autre). Les éléments
 * NON zoomés qui se calent sur ces barres (le conteneur du canvas) utilisent
 * les px écran.
 *
 * Les variables sont posées sur <html> le temps de l'outil, pour que les
 * éléments téléportés dans <body> (pavé numérique, dock de l'outil texte…) les
 * voient. Le viewer suit de lui-même le changement de taille de sa zone (cf. le
 * ResizeObserver de DrawingCanvas.vue). Les modales ne sont pas zoomées.
 */
export function useCanvasUiScale(): void {
  const apply = () => {
    const style = document.documentElement.style;
    style.setProperty(CANVAS_ICON_SCALE_VAR, String(getCanvasIconScale()));
    style.setProperty(CANVAS_TEXT_SCALE_VAR, String(getCanvasTextScale()));
  };

  onMounted(apply);

  watch(() => [Settings.canvasIconSize, Settings.canvasTextSize], apply);

  onBeforeUnmount(() => {
    const style = document.documentElement.style;
    style.removeProperty(CANVAS_ICON_SCALE_VAR);
    style.removeProperty(CANVAS_TEXT_SCALE_VAR);
  });
}
